// Import helpers
import { isNextText } from 'helpers/tags';

// Import styles
import { MetadataLists, List, ListItem } from './styles';

// Import types
import { type MetadataList, MetadataListType } from 'types/api/products/product';

type Props = {
	metadataLists: MetadataList[][];
};

const ProductMetadata = ({ metadataLists = [] }: Props) => {
	const metadata = metadataLists?.filter((list) => list.length);

	if (!metadata?.length) return null;

	return (
		<MetadataLists>
			{metadata.map((list, index) => (
				<List key={index}>
					{list.map(({ type, value }, i, arr) => (
						<ListItem key={value} modifiers={type} isNextText={isNextText(arr[i + 1])}>
							{type === MetadataListType.Icon ? <img src={value} alt={type} loading="lazy" /> : <span>{value}</span>}
						</ListItem>
					))}
				</List>
			))}
		</MetadataLists>
	);
};

export default ProductMetadata;
